import { ROUTE_RELOAD } from '@/models/Route';
import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { getRouteState } from '../routeController/selector';
import { routeSliceActions } from '../routeController/slice';

export const Lobbyw = () => {
    const [reload, setReload] = useState<boolean>(false);
    const { refreshTo, toPage } = useSelector(getRouteState);
    const dispatch = useDispatch();

    useEffect(() => {
        if (refreshTo && toPage != ROUTE_RELOAD && !reload) {
            // console.log('????', refreshTo, toPage);
            setReload(true);
            dispatch(routeSliceActions.close());
        }
    }, [refreshTo]);
    return <>{reload && <Navigate to={toPage} />}</>;
};
